<template>
	<div class="main">
		<div class="item" v-for="item in sloganList" :key="item.id">
			<div class="tit">{{item.titEn}}</div>
			<div class="des">{{item.introEn}}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Slogan",
	data() {
		return {
			sloganList: []
		}
	},
	mounted() {
		this.$api.get('about/getSlogan').then(res => {
			this.sloganList = res;
		});
	}
}
</script>

<style scoped>
.tit{ font-family: 'SiYuan-Light', sans-serif; }
.des{ font-family: 'SiYuan-ExtraLight', sans-serif; }
@media (max-width: 500px){
	.main{ display: flex; flex-wrap: wrap; justify-content: space-around; padding: 18px 0 20px 0; }
	.item{ width: 90%; height: 300px; margin-bottom: 30px; overflow: hidden; border-radius: 16px; background-color: #9ec1d9; animation: fadeInUp; animation-duration: 1.2s; }
	.tit, .des{ display: flex; margin: 0 auto; justify-content: center; }
	.tit{ width: 80%; height: 30%; align-items: flex-end; border-bottom: 1px solid #555555; padding-bottom: 20px; font-size: 20px; }
	.des{ width: 80%; height: 60%; align-items: center; white-space: pre-wrap; font-size: 14px; line-height: 30px; }
}
@media (min-width: 500px) and (max-width: 726px){
	.main{ display: flex; flex-wrap: wrap; justify-content: space-around; padding: 20px 0 20px 0; }
	.item{ width: 46%; height: 300px; margin-bottom: 30px; overflow: hidden; border-radius: 16px; background-color: #9ec1d9; animation: fadeInUp; animation-duration: 1.2s; }
	.tit, .des{ display: flex; margin: 0 auto; justify-content: center; }
	.tit{ width: 80%; height: 30%; align-items: flex-end; border-bottom: 1px solid #555555; padding-bottom: 20px; font-size: 20px; }
	.des{ width: 80%; height: 60%; align-items: center; white-space: pre-wrap; font-size: 14px; line-height: 28px; }
}
@media (min-width: 726px) and (max-width: 999px){
	.main{ display: flex; flex-wrap: wrap; justify-content: space-around; padding: 28px 0 20px 0; }
	.item{ width: 30%; height: 300px; margin-bottom: 30px; overflow: hidden; border-radius: 16px; background-color: #9ec1d9; animation: fadeInUp; animation-duration: 1.2s; }
	.tit, .des{ display: flex; margin: 0 auto; justify-content: center; }
	.tit{ width: 80%; height: 30%; align-items: flex-end; border-bottom: 1px solid #555555; padding-bottom: 20px; font-size: 20px; }
	.des{ width: 80%; height: 60%; align-items: center; white-space: pre-wrap; font-size: 14px; line-height: 24px; }
}
@media (min-width: 999px) and (max-width: 1251px){
	.main{ display: flex; flex-wrap: wrap; justify-content: space-around; padding: 32px 0 20px 0; }
	.item{ width: 23%; height: 300px; margin-bottom: 30px; overflow: hidden; border-radius: 16px; background-color: #9ec1d9; animation: fadeInUp; animation-duration: 1.2s; }
	.tit, .des{ display: flex; margin: 0 auto; justify-content: center; }
	.tit{ width: 80%; height: 30%; align-items: flex-end; border-bottom: 1px solid #555555; padding-bottom: 20px; font-size: 20px; }
	.des{ width: 80%; height: 60%; align-items: center; white-space: pre-wrap; font-size: 14px; line-height: 22px; }
}
@media (min-width: 1252px) and (max-width: 1845px){
	.main{ display: flex; justify-content: space-between; padding: 36px 0 20px 0; }
	.item{ width: 13%; height: 300px; overflow: hidden; border-radius: 16px; background-color: #9ec1d9; animation: fadeInUp; animation-duration: 1.2s; }
	.tit, .des{ display: flex; margin: 0 auto; justify-content: center; }
	.tit{ width: 80%; height: 30%; align-items: flex-end; border-bottom: 1px solid #555555; padding-bottom: 20px; font-size: 18px; }
	.des{ width: 80%; height: 60%; align-items: center; white-space: pre-wrap; font-size: 12px; }
}
@media (min-width: 1846px) and (max-width: 2200px){
	.main{ display: flex; justify-content: space-between; padding: 50px 0 20px 0; }
	.item{ width: 13%; height: 300px; overflow: hidden; border-radius: 16px; background-color: #9ec1d9; animation: fadeInUp; animation-duration: 1.2s; }
	.tit, .des{ display: flex; margin: 0 auto; justify-content: center; }
	.tit{ width: 80%; height: 30%; align-items: flex-end; border-bottom: 1px solid #555555; padding-bottom: 20px; font-size: 20px; }
	.des{ width: 80%; height: 60%; align-items: center; white-space: pre-wrap; font-size: 14px; line-height: 25px; }
}
@media (min-width: 2201px){
	.main{ display: flex; justify-content: space-between; padding: 50px 0 20px 0; }
	.item{ width: 13%; height: 300px; overflow: hidden; border-radius: 16px; background-color: #9ec1d9; animation: fadeInUp; animation-duration: 1.2s; }
	.tit, .des{ display: flex; margin: 0 auto; justify-content: center; }
	.tit{ width: 80%; height: 30%; align-items: flex-end; border-bottom: 1px solid #555555; padding-bottom: 20px; font-size: 20px; }
	.des{ width: 80%; height: 60%; align-items: center; white-space: pre-wrap; font-size: 14px; line-height: 30px; }
}
</style>